import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-legenda-iqar',
  templateUrl: './legenda-iqar.component.html',
  styleUrls: ['./legenda-iqar.component.scss'],
})
export class LegendaIqarComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
